import React, { useEffect, useRef } from "react";
import { Wrapper } from "../styles/components/Global/Global";
import {
  TextContainer,
  AbsoluteText,
  Paragraph,
  ImageBlock,
  ImageContainer,
  Image,
} from "../styles/components/Global/Text";
import animations from "./Animations";

const SplitImage = ({ text }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      animations.parallax(containerRef.current);
    }, 1000);
  }, []);

  return (
    <Wrapper $margin>
      <TextContainer $direction="row" $height="80vh" $flex>
        <ImageBlock>
          <ImageContainer $full>
            <Image
              src="https://www.datocms-assets.com/40484/1695303693-sh01004_008_lotus_eletre_r34_detail_comp05_rbn_finalart_lotus.png"
              $full
            />
          </ImageContainer>
        </ImageBlock>
        <TextContainer
          ref={containerRef}
          $width="25%"
          $margin="0"
          $direction="row"
          $flex
        >
          <AbsoluteText>
            <Paragraph
              dangerouslySetInnerHTML={{ __html: text }}
              $textAlign="left"
              $size="large"
            ></Paragraph>
          </AbsoluteText>
        </TextContainer>
      </TextContainer>
    </Wrapper>
  );
};

export default SplitImage;
